import React from "react";

const FormVideos = (props) => {
  const { values, handleChange, handleBlur, errors, touched, setFieldValue } =
    props;
  return (
    <React.Fragment>
      <div className="add_utf_listing_section margin-top-45">
        <div className="utf_add_listing_part_headline_part">
          <h3>
            <i className="sl sl-icon-tag"></i> Video Gallery
          </h3>
        </div>
        <div className="row with-forms">
          <div className="col-md-12">
            <p>
              If you have some videos that you'd like to show and interact with
              your potential clients, here's the place for it. Use YouTube
              sharing link to show up to three videos for your listing. Note
              that videos might not be displayed, depending on the subscription
              you have for your listing.
            </p>
          </div>
          <div className="col-md-12">
            <h5>Video 1</h5>
            <input
              type="url"
              name="video_1"
              id="video_1"
              placeholder="https://www.youtube.com/watch?v=b1kbLwvqugk"
              value={`${values.video_1 || ''}`}
              onChange={handleChange}
              onBlur={handleBlur}
              className={
                errors.video_1 && touched.video_1
                  ? "search-field error"
                  : "search-field"
              }
            />
          </div>
          <div className="col-md-12">
            <h5>Video 2</h5>
            <input
              type="url"
              name="video_2"
              id="video_2"
              placeholder="https://www.youtube.com/watch?v=b1kbLwvqugk"
              value={`${values.video_2 || ''}`}
              onChange={handleChange}
              onBlur={handleBlur}
              className={
                errors.video_2 && touched.video_2
                  ? "search-field error"
                  : "search-field"
              }
            />
          </div>
          <div className="col-md-12">
            <h5>Video 3</h5>
            <input
              type="url"
              name="video_3"
              id="video_3"
              placeholder="https://www.youtube.com/watch?v=b1kbLwvqugk"
              value={`${values.video_3 || ''}`}
              onChange={handleChange}
              onBlur={handleBlur}
              className={
                errors.video_3 && touched.video_3
                  ? "search-field error"
                  : "search-field"
              }
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default FormVideos;
